import React,{ useEffect } from "react";
import { FindDriver } from '../../components';
import { v4 as uuidv4 } from "uuid";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { utils } from "../../utils";

const FindDriverScreen = ({logPage}) => 
{	
	const navigate = useNavigate();
	const location = useLocation();
	
	
	useEffect(() => {
		document.title = `Find Driver | Order Online | ErrandLocal`;		
	}, []);
	
	useEffect(() => {
		document.body.style.overflow = "auto";
	}, []);
	
	useEffect(() => {
		const checkLogin = async() => {
			const sessionemail = await utils.getStorage('__el_data_email');
			const redirect = await utils.checkLogin(sessionemail);
			if((redirect && sessionemail) || redirect){
				navigate(redirect);
			}
		}
		checkLogin();
	}, []);
	
	useEffect(() => {
		const ref = document.referrer;
    const loc = location.pathname;
		logPage(ref, loc);
	}, []);
	
	
  
	function convertAddress(address){
		return address.toLowerCase().replace(/[^0-9a-zA-Z -]/g, '').replace(/ /g, '-').replace(/--/g, '-');
	}
	
	const SwitchRef = (ref) => {
		navigate(ref);
	}
	
	return (
		<>		
			<FindDriver key={uuidv4()} />
		</>			
	)
};

export default FindDriverScreen;
